import { render } from "./DiscountCoinIcon.vue?vue&type=template&id=306d6a7d"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DiscountCoinIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "306d6a7d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('306d6a7d', __exports__)) {
    api.reload('306d6a7d', __exports__)
  }
  
  module.hot.accept("./DiscountCoinIcon.vue?vue&type=template&id=306d6a7d", () => {
    api.rerender('306d6a7d', render)
  })

}


export default __exports__